import "./Loading.scss";

export const Loading = () => {
  return (
    <div className="loading">
      <div className="loading__circle"></div>
    </div>
  );
};
